import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderContainerBotoes = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
`;

export const DivAcoesLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;
